import {
  RefObject,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import Swiper from 'swiper';
import { STORY_DETAIL_LIST_DURATION } from '#advertStory/constants';
import { UseChangeTimerResultType } from '#advertStory/detail-list';

const useChangeTimer = (
  refSwiperInstance: RefObject<Swiper>,
): UseChangeTimerResultType => {
  const refChangeTimerId = useRef<NodeJS.Timeout | null>(null);

  const stopChangeTimer = useCallback((): void => {
    if (refChangeTimerId.current) {
      clearTimeout(refChangeTimerId.current);
    }
  }, []);

  const startChangeTimer = useCallback(
    (durationForce: number = STORY_DETAIL_LIST_DURATION): void => {
      stopChangeTimer();
      refChangeTimerId.current = setTimeout((): void => {
        refSwiperInstance.current.slideNext();
      }, durationForce);
    },
    [stopChangeTimer, refSwiperInstance],
  );

  useEffect(() => {
    startChangeTimer();

    return () => {
      stopChangeTimer();
    };
  }, [startChangeTimer, stopChangeTimer]);

  return {
    stopChangeTimer,
    startChangeTimer,
  };
};

export { useChangeTimer };
